import { media, styled } from '@styles';

export const ColorCheckbox = styled.div`
  cursor: pointer;
  position: relative;
`;

export const Label = styled.label<{ disabled: boolean }>`
  width: 80px;
  ${media.xSmallScreen`
    width: 40px;
  `};
  ${media.smMediumScreen`
    width: 60px;
  `};
  display: flex;
  flex-direction: column;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  justify-content: flex-start;
  align-items: center;
  input[type='checkbox'] {
    display: none;
    position: relative;
    right: -999em;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      border-radius: 6px;
      width: 80px;
      height: 80px;
      ${media.smMediumScreen`
        width: 60px;
        height: 60px;
      `};
      ${media.xSmallScreen`
        width: 40px;
        height: 40px;
      `};
      background-position: center;
      border: 1px solid transparent;
      position: relative;
      .color-checkbox__icon {
        &-check,
        &-cross {
          position: absolute;
          top: 6px;
          right: 6px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #ca9c66;
          justify-content: center;
          align-items: center;
          display: none;
          svg {
            transform: scale(0.5);
          }
        }
      }
    }

    :focus {
      outline: none;
    }
  }

  ${(props) =>
    props.disabled
      ? ''
      : `&:hover {
          div {
            opacity: 1;
            span {
              .color-checkbox__icon-check {
                display: flex;
                background: #d0d3d8;
                opacity: 0.5;
                border: 1.5px solid #839098;
                svg {
                  display: none;
                }
              }
            }
          }
        }`}

  span {
    ${media.smMediumScreen`
      max-width: 60px;
    `};
    ${media.xSmallScreen`
      max-width: 40px;
    `};
    max-width: 80px;
    font-size: ${(props) => props.theme.typography.baseFontSize};
    line-height: ${(props) => props.theme.typography.baseLineHeight};
  }

  input:checked + div {
    span {
      border: 1px solid #c34c3e;
      .color-checkbox__icon {
        &-check {
          display: flex;
        }
      }
    }
    &:hover {
      span {
        .color-checkbox__icon {
          &-check {
            display: none;
          }
          &-cross {
            display: flex;
          }
        }
      }
    }
  }
`;

export const Name = styled.div<{ disabled: boolean; checked: boolean }>`
  font-size: ${(props) => props.theme.typography.smallFontSize};
  line-height: 1rem;
  text-align: center;
  opacity: ${(props: { disabled: boolean; checked: boolean }): number =>
    props.checked && !props.disabled ? 1 : 0.3};
`;
